import angular from 'angular';
import {
  loaderService,
  reportsSharedModelService
} from 'app/services';
import { alerts } from 'app/components/global';

import directive from './report-type.directive';
import controller from './report-type.controller';

import reportInstances from './reportInstances';
import bulkArchiveGeneratedReportInstancesDialog from './dialog.bulkArchiveGeneratedReportInstancesDialog';


export default angular.module('app.components.reports.generatedReports.reportType', [
  loaderService,
  reportsSharedModelService,
  alerts,
  reportInstances,
  bulkArchiveGeneratedReportInstancesDialog
])
  .directive('grReportType', directive)
  .controller('GRReportTypeController', controller)
  .name;

console.log('app.components.reports.generatedReports.reportType created');
